"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSceneModelObject = exports.SceneModelObject = void 0;
const MemoizedString_1 = require("./MemoizedString");
const ObservableEntity_1 = require("./ObservableEntity");
class SceneModelObject extends ObservableEntity_1.ObservableEntity {
}
exports.SceneModelObject = SceneModelObject;
function makeSceneModelObject(dto) {
    return new SceneObjectImp(dto);
}
exports.makeSceneModelObject = makeSceneModelObject;
class SceneObjectImp extends SceneModelObject {
    constructor(dto) {
        super();
        this._label = new MemoizedString_1.MemoizedString("", this.notify);
        this._meshPaths = [];
        this.addMeshPath = (path) => {
            if (this._meshPaths.includes(path))
                return;
            this._meshPaths.push(path);
            this.notify();
        };
        this.hasMeshPath = (path) => {
            return this._meshPaths.includes(path);
        };
        this.removeMeshPath = (path) => {
            const index = this._meshPaths.indexOf(path);
            if (index >= 0) {
                this._meshPaths.splice(index, 1);
                this.notify();
            }
        };
        this.toData = () => {
            const dto = {
                version: 1,
                id: this.id,
                label: this.label,
                meshPaths: [...this._meshPaths],
            };
            return dto;
        };
        this.applyData = (data) => {
            this.label = data.label;
            this.meshPaths = data.meshPaths;
        };
        this.id = dto.id;
        this._label.setValQuietly(dto.label);
        this._meshPaths = [...dto.meshPaths];
    }
    get label() {
        return this._label.val;
    }
    set label(label) {
        this._label.val = label;
    }
    get meshPaths() {
        return [...this._meshPaths];
    }
    set meshPaths(paths) {
        let pathsHaveChanged = false;
        if (paths.length !== this._meshPaths.length) {
            pathsHaveChanged = true;
        }
        else {
            paths.forEach((path, i) => {
                if (path !== this._meshPaths[i]) {
                    pathsHaveChanged = true;
                }
            });
        }
        if (!pathsHaveChanged)
            return;
        this._meshPaths = paths;
        this.notify();
    }
}
